/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.library").
controller("DxLibraryGradingMatrixItemController", function LibraryGradingMatrixItemController(
	$scope,
	$rootScope,

	dxDialog
) {
	"use strict";

	$scope.itemActions = {
		preview: function preview(item) {
			var scope = $rootScope.$new();
			scope.matrix = item;
			return dxDialog.show({
				templateUrl: "/partials/popups/view-grading-matrix.html",
				$scope: scope,
			});
		},
	};
});
